__turbopack_context__.v({
  "fieldLabel": "AITextField-module__SpPrAa__fieldLabel",
  "fieldLabelRequired": "AITextField-module__SpPrAa__fieldLabelRequired",
  "fieldWrapper": "AITextField-module__SpPrAa__fieldWrapper",
  "headerActionsGroup": "AITextField-module__SpPrAa__headerActionsGroup",
  "historyControls": "AITextField-module__SpPrAa__historyControls",
  "improveButton": "AITextField-module__SpPrAa__improveButton",
  "labelRow": "AITextField-module__SpPrAa__labelRow",
  "skeleton-shimmer": "AITextField-module__SpPrAa__skeleton-shimmer",
  "skeletonLine": "AITextField-module__SpPrAa__skeletonLine",
  "skeletonOverlay": "AITextField-module__SpPrAa__skeletonOverlay",
  "solaBar": "AITextField-module__SpPrAa__solaBar",
  "solaIcon": "AITextField-module__SpPrAa__solaIcon",
  "undoButton": "AITextField-module__SpPrAa__undoButton",
  "versionChip": "AITextField-module__SpPrAa__versionChip",
  "wrapper": "AITextField-module__SpPrAa__wrapper",
});
